import { CoordinatorService } from "./coordinator.service"

export class Eduid$ {
    constructor(public coords: CoordinatorService) {

    }

    async ntkLogin() {
        // console.log("START NTK LOGIN :")
        // window.open(`/directNTKLgn/?isLogin=true`, '_blank')
        const host = window.location.host
        console.log("START NTK LOGIN :", host)
        window.open(`https://referentka.app/eduid/?tkn=login&tp=ntk&h=https://${host}`)

    }

    async eduidResponse(eduid: string, eduiv: string) {
        const resp = await this.coords.firebase$
            .callFunction("eduidProcessing", {
                eduid: eduid,
                eduiv: eduiv
            }) as any

        this.coords.appChannelPost({
            action: "loginTkn",
            tkn: resp.data
        })

        setTimeout(() => window.close(), 1000)
    }
    // async eduidDirectLogin() {
    //     const resp = await this.firebase$
    //         .callFunction("getNtkAuth", {
    //             email: "pokus1@techlib.cz"
    //         })
    //     if (resp === "ERROR") return
    //     const result = await this.firebase$.customTokenLogin((resp.data as any).tkn)
    //     this.display$.closeDialog()
    // }

}
